// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import * as ActiveStorage from '@rails/activestorage';
import 'channels';
import 'jquery';
import 'jquery-ui';
import bsCustomFileInput from 'bs-custom-file-input';

Rails.start();
Turbolinks.start();
ActiveStorage.start();

window.$ = $;
window.jquery = $;
window.jQuery = $;

require('stylesheets/application');
require('javascripts/application');

$(document).on('turbolinks:load', function () {
  bsCustomFileInput.init();

  let defaultFontSize = 100;
  let factor = 1;

  $('#font-increase').on('click', function () {
    modifyFontSize('increase');
  });

  $('#font-decrease').on('click', function () {
    modifyFontSize('decrease');
  });

  $('#font-reset').on('click', function () {
    modifyFontSize('reset');
  });

  function modifyFontSize(action) {
    if (action == 'increase') {
      factor += 0.1;
    } else if (action == 'decrease') {
      factor -= 0.1;
    } else {
      factor = 1;
    }

    let fontSize = defaultFontSize * factor + '%';

    $('html').css('font-size', fontSize);
  }
});
